import { render, staticRenderFns } from "./box-9-unit-1.vue?vue&type=template&id=91d884c0&scoped=true&"
import script from "./box-9-unit-1.vue?vue&type=script&lang=ts&"
export * from "./box-9-unit-1.vue?vue&type=script&lang=ts&"
import style0 from "./box-9-unit-1.vue?vue&type=style&index=0&id=91d884c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d884c0",
  null
  
)

export default component.exports